<template>
	<component
		class="btn"
		:is="href ? 'a' : 'button'" 
		:href="href ? href : null"
		@click="to ? goTo(to) : null">
		<div class="spinner"></div>
		<slot></slot>
	</component>
</template>

<script>
export default {
	name: "j-button",
	props: {
		to: {
			type: String,
		},
		href: {
			type: String,
		},
	},
	methods: {
		goTo(where) {
			this.$router.push(`${where}`)
		},
	},
}
</script>

<style scoped>
@import "../../assets/css/tokens.css";

/**************
	Normal
***************/
.btn {
	display: inline-flex;
	justify-content: center;
	align-items: center;
	min-height: 40px;
	padding: 0 var(--spacing5);
	border: 1px solid var(--color0);
	outline: 0;
	border-radius: var(--borderRadius2);
	background-color: var(--colorSuccess);
	opacity: .8;
	color: var(--color5);
	font-size: var(--fontSize3);
	line-height: var(--lineHeight100);
	font-weight: var(--fontWeight7);
	text-decoration: none;
	white-space: nowrap;
	transition: all 170ms ease-out;
	cursor: pointer;
}

/**************
	States
***************/
@media (--md) {
	.btn:hover {
		/* background-color: var(--color3-light-1); */
		background-color: var(--colorSuccess);
		opacity: 1;
	}

	.btn:active {
		transform: translateY(-2px);
	}
}

/**************
	Sizes
***************/

/* small */
.btn.small {
	min-height: 32px;
	padding: 0 var(--spacing2);
	font-size: var(--fontSize2);
}

/* large */
.btn.large {
	min-height: 48px;
	font-size: var(--fontSize4);
}

/* giantic */
.btn.giantic {
	min-height: 56px;
	font-size: var(--fontSize5);
}

/**************
	Variations
***************/

/* Secondary style */
.btn.secondary {
	background-color: var(--color5);
	border-color: var(--color7);
	color: var(--color6);
}

.btn.secondary:hover {
	color: var(--color1);
}

.btn.secondary:active {
	transform: translateY(-2px);
}

/* tertiary style */
.btn.tertiary {
	background-color: var(--color0);
	border-color: var(--color0);
	color: var(--color2);
	padding: 0;
	min-height: auto;
}

.btn.tertiary:hover {
	color: var(--color2-light-2);
}

.btn.tertiary:active {
	transform: translateY(0);
	color: var(--color2-light-3);
}

/* Error */
.btn.error {
	background-color: var(--color5);
	border-color: var(--color3);
	color: var(--color3);
}

.btn.error:hover {
	color: var(--color3-light-2);
}

.btn.error:active {
	transform: translateY(-2px);
}

/**************
	Disabled, loading
***************/
.disabled {
	opacity: 0.7;
	pointer-events: none;
	filter: grayscale();
}

/**************
	Icon reset
***************/
.btn > i {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
	font-size: inherit;
	font-weight: inherit;
	margin-right: var(--spacing1);
}

/**************
	Loading
***************/
.loading {
	pointer-events: none;
}
.spinner {
	display: none;
}
.loading .spinner {
	display: inline-block;
	width: 24px;
	height: 24px;
	border: 3px solid rgba(255, 255, 255, 0.3);
	border-radius: 50%;
	border-top-color: var(--color5);
	margin-right: var(--spacing2);
	animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
	to {
		transform: rotate(360deg);
	}
}
</style>



// WEBPACK FOOTER //
// src/components/JButton/index.vue